import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 42;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1.5" data-id="element-92" data-mp="k30youdzwkkr">
      <span className="font-display text-2xl font-black tabular-nums tracking-wide sm:text-3xl" style={{
      fontFamily: 'Montserrat, sans-serif',
      fontSize: "20px"
    }} data-id="element-93" data-mp="5d39qc88rqui">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-bold uppercase tracking-widest sm:text-xs" data-id="element-94" data-mp="3sh9cgwbuz6sv">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Launch offer countdown" className="fixed inset-x-0 top-0 z-50 bg-grape text-white shadow-[0_6px_20px_-10px_rgba(46,21,18,0.6)]" data-id="element-95" data-mp="qyk47zbk5hwa">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-6" style={{
      paddingTop: "5px",
      paddingBottom: "6px",
      width: "374px",
      height: "40px",
      paddingRight: "35px"
    }} data-id="element-96" data-mp="10y1768zfdhok">
        <p className="flex items-center gap-2.5 text-[13px] font-extrabold uppercase leading-tight tracking-[0.18em] sm:text-base sm:tracking-[0.22em]" data-id="element-97" data-mp="88anlkf0xnl2">
          <HourglassIcon className="h-5 w-5 shrink-0" aria-hidden="true" style={{
          width: "17px",
          height: "19px"
        }} data-id="element-98" data-mp="37o50h4rvkf0" />
          <span style={{
          fontSize: "8px"
        }} data-id="element-99" data-mp="d86srmzgjl27">Launch offer ends in:</span>
        </p>

        <p className="flex shrink-0 items-baseline gap-1.5 sm:gap-2.5" data-id="element-100" data-mp="3lngtaqnp8i7v">
          <Unit value={mm} label="Min" data-id="element-101" data-mp="3llnjx3lpbjw6" />
          <span className="text-xl font-black opacity-70" data-id="element-102" data-mp="3gp5h499xlvmh">:</span>
          <Unit value={ss} label="Sec" data-id="element-103" data-mp="3gmt2a4zh01dn" />
        </p>
      </div>
    </div>;
}